import React from 'react';

import styles from './letterBox.module.css';

export default function Hr() {
  return <hr className={styles.hr} />;
}
